// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","691":"component---src-pages-index-tsx","944":"component---src-pages-[id]-index-tsx"}[chunkId] + "-" + {"351":"a4b1148a295bdaa9e5e3","532":"db9764d2db0a3854c1e3","691":"48c4d222dd53966d2e8e","944":"35458bba4016bfe9b977"}[chunkId] + ".js";
};